import type { InferInsertModel, InferSelectModel } from 'drizzle-orm';
import {
  boolean,
  doublePrecision,
  pgEnum,
  pgTable,
  text,
  timestamp,
  uuid,
} from 'drizzle-orm/pg-core';

export const additionalOptionScopeEnum = pgEnum('additional_option_scope', [
  'item',
  'sale',
]);
export const additionalOptionValueTypeEnum = pgEnum('additional_option_value_type', [
  'percentage',
  'fixed',
]);

export const additionalOptions = pgTable('additional_options', {
  id: uuid('id')
    .primaryKey()
    .$defaultFn(() => Bun.randomUUIDv7()),
  label: text('label').notNull(),
  slug: text('slug').notNull().unique(),
  scope: additionalOptionScopeEnum('scope').notNull(),
  valueType: additionalOptionValueTypeEnum('value_type').notNull(),
  value: doublePrecision('value').notNull(),
  isActive: boolean('is_active').default(true),
  createdAt: timestamp('created_at')
    .notNull()
    .$defaultFn(() => new Date()),
  updatedAt: timestamp('updated_at')
    .$onUpdate(() => new Date())
    .notNull(),
});

export type AdditionalOption = InferSelectModel<typeof additionalOptions>;
export type CreateAdditionalOptionInput = InferInsertModel<typeof additionalOptions>;
export type UpdateAdditionalOptionInput = Partial<CreateAdditionalOptionInput>;
